<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo class="d-none d-lg-block" />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('404_page_header') }}
        </h2>
        <p class="mb-2">
          {{ $t('404_page_description') }}
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{name:'dashboard'}"
        >
          {{ $t('404_page_btn') }}
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import logo from '@/views/theme1/components/logo.vue'
import Error404 from '@/views/logics/error/Error404'

export default {
  components: {
    logo,
  },
  mixins: [Error404],
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
